import styled from '@emotion/styled';
export const FilterContainer = styled.div`
  margin-bottom: 24px;
  width: 400px;
`;
export const FilterInput = styled.input`
  max-width: 100%;
  width: 500px;
`;
